import { Typography } from "@material-ui/core";
import { get } from "lodash";
import React from "react";

interface IPriceField {
  record?: {};
  source: string;
  label?: string;
}

const CustomPriceField = ({ record = {}, source }: IPriceField) => {
  const price = get(record, source);

  if (price >= 0) {
    return <Typography variant="body2">$ {price.toFixed(2) / 100}</Typography>;
  } else {
    return <Typography variant="body2">-</Typography>;
  }
};

export default CustomPriceField;
